import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import Loading from "../components/common/Loading";
import {
  getAccessToken,
  getLoginWithTokenStatus,
  getUser,
  loginwithtoken,
  removeLoginWithTokenMessage,
} from "../redux/slice/userSlice";

const RequireAuth = ({ allowedRoles }) => {
  const dispatch = useDispatch();
  const token = useSelector(getAccessToken);
  const location = useLocation();
  const user = useSelector(getUser);
  const status = useSelector(getLoginWithTokenStatus);

  useEffect(() => {
    if (token && !user) {
      dispatch(loginwithtoken(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "failed") {
    dispatch(removeLoginWithTokenMessage());
    return <Navigate to="/login" replace />;
  }

  if (token && !user?.role) {
    return <Loading />;
  }

  return token ? (
    allowedRoles.find((role) => user?.role === role) ? (
      <Outlet />
    ) : (
      <Navigate
        to="/unauthorized"
        state={{ from: location, role: user?.role, allowedRole: allowedRoles }}
        replace
      />
    )
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
